export const en = {
  "AppName": "PG&E Claims",
  "Calendar": "Calendar",
  "ShowTimePicker": "Show time picker",
  "Questionnaire": "Questionnaire",
  "ClaimantHeading": "Claimant information",
  "IncidentInformationHeading": "Incident information",
  "ClaimDetailsHeading": "Claim details",
  "Witnesses": "Witnesses",
  "Supporting_documents": "Supporting documents",
  "Confirmation": "Confirmation",
  "Stepper_1": "1. Questionnaire",
  "Stepper_2": "2. Claimant information",
  "Stepper_3": "3. Incident information",
  "Stepper_4": "4. Claim details",
  "Stepper_5": "5. Witnesses",
  "Stepper_6": "6. Supporting documents",
  "Stepper_7": "7. Confirmation",
  "QuestionnaireDesc": "We understand that you have sustained a loss for which you believe PG&E may be responsible. To evaluate your claim, please provide the following information.",
  "InitialQuestion1":"Is your claim related to a storm, an electric outage or a Public Safety Power Shutdown Event?",
  "Yes": "Yes",
  "No": "No",
  "QuestionnaireDescYes": "If you are a residential customer who has gone without power for 48 consecutive hours or greater because of severe storm conditions, you may qualify for an automatic payment under our Safety Net program. This program provides a payment of $25-100, which is paid automatically about 60 days following the storm outage.",
  "QuestionnaireMoreInfo": "For more information regarding Safety Net payments",
  "QuestionnaireMoreInfoLink": " visit outage compensation",
  "QuestionnaireAutomaticProgram": "This is an automatic program based on eligibility, no further action is required.",
  "FullStop": ". ",
  "InitialQuestion": "Do you still want to file a claim (YES/NO)",
  "InitialQuestion3Info": "Generally speaking, PG&E is not responsible for damages that we do not cause or that are the result of forces beyond our control. For example, in most instances, we are not responsible in the following situations: Power outages, voltage fluctuations or property damage caused by weather-related conditions, such as lightning, floods, storms, vegetation (tree/branches), heat or winds, earthquakes, or other acts of nature.",
  "Error": "Error: Please select an answer",
  "Next": "Next",
  "Helpline": "If you have trouble submitting your claim online, please contact PG&E’s claims helpline at",
  "ForAssistance.": "for assistance.",
  "Information": "Information",
  "RequiredField": "*required field",
  "AccountNumber": "PG&E account number",
  "AccountNumberTooltip": "Your account number is in the upper right corner of your monthly PG&E energy statement.",
  "AccountNumberOptional": "This field is optional.",
  "accountnumber": "account_number",
  "InvalidAcNmbr": "invalid Account Number",
  "BusinessName": "Business name",
  "FirstName":"First name",
  "LastName":"Last name",
  "MailingAddress":"Mailing address",
  "AptSuite":"Apt/Suite",
  "City":"City",
  "ZIPCode":"ZIP code",
  "State":"State",
  "PhoneNumber": "Phone number",
  "PrimaryPhone":"Primary phone number",
  "AlternatePhone":"Alternate phone number",
  "Email":"Email address",
  "ConfirmEmail":"Confirm email address",
  "AreYouPG&EEmployee":"Are you a PG&E employee?",
  "PGEEmployee": "PG&E employee",
  "LANID":"LAN ID",
  "Back": "Back", 
  "ErrorAccountNumberDigits": "Error: Please enter at least 10 digits",
  "ErrorFirstNameRequired": "Error: First name is required",
  "ErrorLastNameRequired": "Error: Last name is required",
  "ErrorMailingAddressRequired": "Error: Mailing address is required",
  "ErrorCityRequired": "Error: City is required",
  "ErrorZipCodeRequired": "Error: Enter ZIP code",
  "ErrorPhneNumbrRequired": "Error: Please enter a valid phone number",
  "ErrorPhoneNumber10Digits": "Error: You must enter a 10-digit phone number",
  "ErrorValidEmail": "Error: Please enter a valid email address",
  "ErrorEmailsMustMatch": "Error: Email addresses must match",
  "ErrorPGEEmployeeRequired": "Error: Are you currently employed by PG&E? If not, select No above",
  "ErrorLANIDRequired": "Error: LAN ID is required",
  "ErrorLANIDValid": "Error: Please enter valid LAN ID",
  "EstimatedDateOfIncident": "Estimated date of incident",
  "IncDate": "mm/dd/yyyy",
  "EstimatedTimeOfIncident": "Estimated time of incident (if known)",
  "Today": "today",
  "SameAsMailingAddress": "Same as mailing address?",
  "Location": "*Location",
  "StreetAddress": "Street address",
  "OtherDescribe": "Other/Describe",
  "IncidentAddress": "Incident address",
  "DescriptionOfLocation": "Description of location",
  "YouHave": "You have",
  "CharactersRemaining": "characters remaining",
  "ErrorPleaseEnterValidDate": "Error: Please enter a valid date",
  "ErrorValidDateFormat": "Error: Please enter a valid date in MM/DD/YYYY format",
  "ErrorFutureDateNotAllowed": "Error: Future date is not allowed",
  "ErrorYearCurrentCentury": "Error: Year should be in current century", 
  "ErrorValidTime12Hour": "Error: Please enter a valid time in 12-hour format",
  "ErrorOneSelectionRequired": "Error: One selection is required",  
  "ErrorIncidentAddressRequired": "Error: Incident address is required",  
  "ErrorLocationDescriptionRequired": "Error: Location description is required",  
  "DescribeWhatHappened": "*Please describe what happened",  
  "Subtotal": "Subtotal",
  "IsThisClaimForBusiness": "Is this a claim for your business?",
  "EstimatedRevenueLoss": "Estimated revenue loss",
  "WagesPaidToHourlyEmployees": "Wages paid to hourly employees",
  "LostInventory": "Lost inventory",
  "WereYouInjured": "Were you injured?",
  "IncidentInvolves": "Incident involves",
  "BodilyInjury": "Bodily injury",
  "PropertyDamageFoodSpoilageLabel": "Property damage/Food spoilage",
  "PropertyDamageOrFoodSpoilage": "Property Damage or Food Spoilage",
  "Both": "Both",
  "IsThisMotorVehicleIncident": "Is this a motor vehicle incident?",
  "VehicleInfo": "Vehicle info",
  "CarMake": "Car make",
  "CarModel": "Car model",
  "CarYear": "Car year",
  "EstimatedDamages": "Estimated damages",
  "LicensePlateNumber": "License plate number",
  "StateRegistered": "State registered",
  "IsClaimantOwnerOfVehicle": "Is claimant owner of vehicle?",
  "VehicleOwnerInformation": "Vehicle owner information",
  "VehicleOwnerFirstName": "Vehicle owner's first name",
  "VehicleOwnerLastName": "Vehicle owner's last name",
  "Address": "Address",
  "Select": "Select",
  "LostWages": "Lost wages (if any)",
  "MedicalExpenses": "Medical expenses (if any)",
  "OtherLosses": "Other losses",
  "PleaseDescribeOtherLosses": "Please describe other losses",
  "TotalAmountClaimed": "Total amount claimed",
  "DamagedItems": "Damaged items (other than vehicle)",
  "AddItem": "Add item",
  "DeleteItem": "Delete item",
  "DeleteItemConfirmation": "Would you like to delete the item?",
  "Delete": "Delete",
  "NoteMoreThan10Items": "Note: If you have more than 10 items, please add a list of items as an attachment in step 4.",
  "UpdateItem": "Update item",
  "MakeBrand": "Make/brand",
  "Model": "Model",
  "Year": "Year",
  "Amount": "*Amount",
  "ItemDescription": "*Item description",
  "Makebrand": "Make/Brand",
  "Itemdescription": "*Item Description",
  "Submit": "Submit",
  "Cancel": "Cancel",
  "ErrorDetailedDescriptionRequired": "Error: Detailed description required",  
  "ErrorBusinessNameRequired": "Error: Business name is required",
  "ErrorCarMakeRequired": "Error: Car make is required",
  "ErrorCarModelRequired": "Error: Car model is required",
  "ErrorCarYearRequired": "Error: Car year is required",
  "ErrorEstimatedDamagesRequired": "Error: Estimated damages is required.",
  "ErrorLicensePlateNumberRequired": "Error: License plate number is required.",
  "ErrorItemDescriptionRequired": "Error: Item description is required",
  "ErrorAmountRequired": "Error: Amount is required",
  "ErrorInvalidAmountEntry": "Error: Invalid amount entry. Please enter value between 0.00 and 10000000.00",
  "ErrorPleaseChooseOptionIncidentInvolves": "Error: Please choose one option for Incident involves",
  "ErrorVehicleOwnerFirstNameRequired": "Error: Vehicle owner's first name is required",
  "ErrorVehicleOwnerLastNameRequired": "Error: Vehicle owner's last name is required",
  "ErrorVehicleOwnerAddressRequired": "Error: Vehicle owner's address is required",
  "ErrorVehicleOwnerCityRequired": "Error: Vehicle owner's city is required",
  "ErrorVehicleOwnerStateRequired": "Error: Vehicle owner's state is required",
  "ErrorValidZipCode": "Error: Please enter a valid ZIP code",
  "ErrorValidZipCodeNumber": "Error: Please enter a valid ZIP code (ex: 12345, 94538)",
  "ErrorVehicleOwnerPhoneRequired": "Error: Vehicle owner's phone is required",
  "ErrorClaimantOwnerOfVehicle": "Error: Please choose one option for Is this a claimant owner of vehicle?",
  "ErrorMotorVehicleIncident": "Error: Choose one option. Is this a motor vehicle incident?",
  "ErrorClaimForBusiness": "Error: Choose one option. Is this a claim for your business?",
  "WitnessesHeading": "Witnesses (Optional)",
  "WitnessesDescription": "If there were no witnesses, you may skip this step. This is typical for injury-related claims. You may add up to three witnesses.",
  "Phone": "Phone",
  "ZIP": "Zip",
  "Firstname": "First Name",
  "Lastname": "Last Name",
  "PGnEEmployee": "PGE Employee",
  "ResultsWillAppearInTable": "Results will appear in a table below.",
  "AddWitness": "Add a witness",
  "ErrorMaxThreeWitnesses": "Error: You may add up to three witnesses",
  "UpdateWitness": "Update witness",
  "DeleteWitness": "Delete witness",
  "DeleteWitnessConfirmation": "Would you like to delete the witness?",
  "ErrorPleaseEnter" :"Error: Please enter",
  "ValidZip": "a valid ZIP code" ,
  "ZipCodeExample": "(ex: 12345, 94538)",
  "SupportingDocumentsHeading": "Add supporting documents",
  "ProcessClaimsDescription": "To process your claims, we will need supporting documents for each item claimed.",
  "AddUpTo10Documents": "Add up to 10 documents (e.g. receipts and estimates)",
  "FilesLessThan10MB": "Files must be less than 10MB each",
  "FileTypesAccepted": "File types accepted: .pdf,.txt,.doc,.docx,.xls,.xlsx,.jpg,.png,.heic or .jpeg.",
  "NOTE": "NOTE:",
  "NoteClaimsRepresentative": "Your claims representative will contact you within the next 3 business days. They can help if you have more than 10 documents or have additional information.",
  "AttachFile": "Attach File",
  "AttachFileInstruction1": "Click the upload icon [",
  "AttachFileInstruction1End": "] and select the file from your desktop.",
  "AttachFileInstruction2": "Click the Upload button.",
  "AttachFileInstruction3": "The files will appear as a list below.",
  "MaxFileSize": "Max. file size: 10MB",
  "Upload": "Upload", 
  "Agreement": "Agreement",
  "FileNotUploaded": "File not uploaded",
  "ErrorUploadDocument": "Error: We have encountered a problem processing your upload document. Please re-upload the document.",
  "FileNotUploadedMessage": "You have not uploaded the selected file, Please click the [Upload ^] button",
  "AgreementTerms": "*By submitting this form I understand that Pacific Gas and Electric Company will review all documentation in support of this claim. I certify that the foregoing information entered is true and correct.",
  "Security": "Security",
  "VerifyNotRobot": "Please verify that you are not a robot.",
  "ErrorReadAgreeTerms": "Error: Please read and agree to the terms.",
  "ErrorVerifyNotRobot": "Error: Verify that you are not a robot",
  "SubmitWithoutAttachment": "Submit without attachment",
  "SubmitWithoutUploadingDocuments": "Do you want to submit this Claim without uploading documents?",
  "SubmitAnyway": "Submit Anyway",
  "DontSubmit": "Don't Submit",
  "ErrorSubmitForm": "Error: We have encountered a problem processing your submit form. Please re-submit the form.",
  "ErrorFileSizeLessThan10MB": "Error: File size must be less than 10MB",
  "ErrorProcessingRequest": "Error: We have encountered a problem processing your request. Please verify that you have entered all the required information and re-submit.",
  "ErrorAllowedFileTypes": "Error: Allowed file types .pdf,.txt,.doc,.docx,.xls,.xlsx,.jpg,.png,.heic,.jpeg",
  "FilesAttached": "Files attached",
  "Ok": "Ok",
  "Recaptcha": "recaptcha",
  "ConfirmationHeading": "Your claim submission has been received.",
  "YourClaimNumberIs": "Your claim number is",
  "ConfirmationDescription": "It is Pacific Gas and Electric Company's policy to promptly and fairly respond to customers' claims. All claims are evaluated on a case-by-case basis. It is our goal to resolve your claim within 30 days of receipt. However, some claims do take longer to investigate and resolve. By submitting supporting documentation for your loss immediately the handling of your claim will be expedited. When our investigation is complete, we will either call you or send you a letter explaining what we found and the basis for our decision.",
  "WhatToExpect": "What to expect",
  "ConfirmationDocument": "If you have not provided supporting documents OR have additional documents to submit (e.g., Receipt, or Estimates for items claimed) please submit your supporting documentation to:",
  "ConfirmationDocumentEmail": "claimsdocs@pge.com?subject=",
  "HelpDesk": "If you have any questions, you can contact our help desk at 415-973-4548.",
  "Sincerely": "Sincerely,",
  "PGEClaimsTeam": "PG&E Claims Team",
  "Age": "Age",
  "Action": "Action",
  "Edit": "Edit",
  "Add": "Add",
  "ErrorFileAlreadyUploaded": "Error: A file with the same name has already been uploaded",
  "InfoBannerText": "If you have trouble submitting your claim online, please contact PG&E’s claims helpline at {{phone}} for assistance.",
  "SessionExpire15": "Your session will expire in 15 minutes.",
  "SessionExpire5": "Your session will expire in 5 minutes.",
  "SessionExpireWarning": "For security reasons, your data will be deleted when the session expires.",
  "StayConnected": "Stay connected",
  "EndSession": "End Session",
  "SessionExpired": "Your session has expired due to inactivity.",
  "SessionDeleted": "For security reasons, your data was deleted.",
  "Accessibility": "Accessibility",
  "TermsAndConditions": "Terms & Conditions",
  "Regulation": "Regulation",
  "Privacy": "Privacy",
  "DoNotSellMyPersonalInformation": "Do Not Sell My Personal Information",
  "SiteMap": "Site Map",
  "CopyrightText": "Pacific Gas and Electric Company",
  "DeleteFile": "Delete a file",
  "RemoveUploadedFileConfirmation": "Would you like to remove the uploaded file?" ,
  "RemoveFile": "Remove file",
  "NoFileChosen": "No file chosen",
  "arrowUP": "An arrow points up to indicate a file upload"  
};